module.exports = __WEBPACK_EXTERNAL_MODULE_https_cdn_web_vanguard_com_c11n_web_b6_segmented_control_js_2be87ae0__;